import * as React from 'react';
import { Context } from './Provider';
function useAppState() {
    const app = React.useContext(Context);
    const initialValue = (app?.data || {});
    const [state, setState] = React.useState(initialValue);
    // Force re-renders when app's data changes
    React.useEffect(() => {
        const unsubscribe = app?.subscribe((newData) => setState(newData));
        return unsubscribe;
    }, [app]);
    // Setter for data in the Hypervisor registry
    const setData = (data) => {
        app.data = { ...state, ...data };
    };
    return [state, setData, app];
}
export default useAppState;
